const ExternalLinkIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className || "shrink-0 text-dark-gray dark:text-dark-gray-dk"}
  >
    <path
      d="M11.375 7.875V11.375C11.375 11.6875 11.2578 11.9609 11.0234 12.1953C10.7891 12.4297 10.5156 12.5469 10.2031 12.5469H2.625C2.3125 12.5469 2.03906 12.4297 1.80469 12.1953C1.57031 11.9609 1.45312 11.6875 1.45312 11.375V3.79688C1.45312 3.48438 1.57031 3.21094 1.80469 2.97656C2.03906 2.74219 2.3125 2.625 2.625 2.625H6.125M8.75 1.45312H12.5469V5.25M5.6875 8.3125L12.25 1.75"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExternalLinkIcon;
